import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NameEntryModal from '../../../NameEntryModal';

class RenameItemButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  renameThisItem = (newName) => {
    this.props.renameItem(this.props.itemId, newName);
  };

  render() {
    return (
      <div className="editItem">
        <button id="editItemButton" className="link" onClick={this.openModal}>
          Rename
        </button>
        <NameEntryModal
          modalIsOpen={this.state.modalIsOpen}
          validate={this.props.validate}
          action={this.renameThisItem}
          title="Rename Window name"
          verb="Save"
          defaultName={this.props.defaultName}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}

RenameItemButton.propTypes = {
  renameItem: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  defaultName: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
};

export default RenameItemButton;
